module.exports = __webpack_public_path__ + "img/omron.5ba3ed89.svg";